module.exports = __webpack_public_path__ + "2oxSBYp2_400x400.webp?efce5032affcdcf0774fa796a424cf59";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/2oxSBYp2_400x400.webp
// module id = 22
// module chunks = 0